// extracted by mini-css-extract-plugin
export default {"card":"HY-z","carouselContainer":"IY-z","carouselContent":"JY-z"};